import { InputAdornment } from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'

export const fieldsAdd = (values, handleChange) => {
  return [
    {
      label: 'Nombre/Razón social',
      name: 'nombre',
      sm: 12,
      xs: 12,
      class: 'textfield',
      value: values.nombre,
      onChange: (e) => handleChange('nombre', e.target.value),
    },
    {
      label: 'Descripción',
      name: 'descripcion',
      sm: 12,
      xs: 12,
      class: 'textfield',
      value: values.descripcion,
      onChange: (e) => handleChange('descripcion', e.target.value),
    },
    {
      label: 'Nº de factura',
      name: 'factura',
      sm: 12,
      xs: 12,
      class: 'textfield',
      value: values.factura,
      onChange: (e) => handleChange('factura', e.target.value),
    },
    {
      label: 'Método de pago',
      name: 'tipo',
      sm: 12,
      xs: 12,
      class: 'textfield',
      value: values.tipo,
      disabled: true,
    },
    {
      label: 'Importe',
      name: 'importe',
      sm: 12,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.importe)),
      onChange: (e) => handleChange('importe', e.target.value),
    },
  ]
}
